module.exports = __webpack_public_path__ + "img/85.8a0782b5.jpg";